import React, { useEffect, useState } from 'react';
import { message } from 'antd';

import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import { KATOService } from 'services/KATOService';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import {
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { KATOForm } from './KATOForm';
import { KATOTable } from './KATOTable';

function KATO() {
  useDocumentTitle('КАТО');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [parentRegions, setParentRegions] = useState([]);
  const { setCount } = useHeaderChanger('КАТО');
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();
  const { page, totalRows, perPage, setTotalRows, setPagination } =
    usePagination();

  useEffect(() => {
    fetchParentRegions();
  }, []);

  useEffect(() => {
    fetchParentRegions();
  }, [items]);

  useEffect(() => {
    fetchItems();
  }, [page, perPage]);

  const fetchItems = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await KATOService.getKATO(page, perPage);

      setItems(items);
      setTotalRows(total);
      setCount(items.length);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const fetchParentRegions = async () => {
    try {
      const data = await KATOService.getParentRegions();

      setParentRegions(data);
    } catch (err) {
      message.error('Не удалось подгрузить область и регионы');
    }
  };

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await KATOService.deleteKATO(activeRecord?.id);

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="kato" />

      <KATOTable
        items={items}
        loading={loading}
        current={page}
        pageSize={perPage}
        totalRows={totalRows}
        onRowClick={openDrawer}
        onChange={setPagination}
      />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={[
          {
            label: 'Наименование области или города',
            key: 'parent',
            computedValue: activeRecord?.parent
              ? activeRecord?.parent?.name_rus
              : '---',
          },
          {
            label: 'Статус',
            key: 'status',
            computedValue: activeRecord?.status ? 'Да' : 'Нет',
          },
          { label: 'Код', key: 'code' },
          { label: 'Наименование на казахском', key: 'name_kaz' },
          { label: 'Наименование на русском', key: 'name_rus' },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить эту запись ?"
        pageId="kato"
      />

      <KATOForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchItems}
        onClose={closeForm}
        parentList={parentRegions}
      />
    </>
  );
}

export { KATO };
